import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { UiSuggestIntl } from '@uipath/angular/components/ui-suggest';
import { takeUntil } from 'rxjs/operators';
var UiAutocompleteIntl = /** @class */ (function (_super) {
    tslib_1.__extends(UiAutocompleteIntl, _super);
    function UiAutocompleteIntl(_translateService) {
        var _this = _super.call(this) || this;
        _this._translateService = _translateService;
        _this.currentItemLabel = function (text, itemNo, itemCount) {
            return _this._translateService.instant('current_item_out_of', { text: text, itemNo: itemNo, itemCount: itemCount });
        };
        _this._updateLabels = function (_a) {
            var item_suggestion_is_loading = _a.item_suggestion_is_loading, select_no_results_text = _a.select_no_results_text, suggest_custom_value = _a.suggest_custom_value, clear_selection = _a.clear_selection;
            _this.noResultsLabel = select_no_results_text;
            _this.loadingLabel = item_suggestion_is_loading;
            _this.customValueLiveLabel = suggest_custom_value;
            _this.clearSelectionLabel = clear_selection;
        };
        _translateService
            .stream([
            'select_no_results_text',
            'item_suggestion_is_loading',
            'suggest_custom_value',
            'clear_selection',
        ])
            .pipe(takeUntil(_this._destroyed$))
            .subscribe(_this._updateLabels);
        return _this;
    }
    return UiAutocompleteIntl;
}(UiSuggestIntl));
export { UiAutocompleteIntl };
